import { useState } from "react";
import Herobanner from "../components/Herobanner/Herobanner.jsx";
import Section from "../components/Section/Section.jsx";
import Chip from "../components/Chip/Chip.jsx";
import CardContainer from "../components/Card/CardContainer.jsx";
import ArticleContainer from "../components/Article/ArticelContainer.jsx";
import CertificationContainer from "../components/Certification/CertificationContainer.jsx";
import Stripbanner from "../components/Stripbanner/Stripbanner.jsx";
import { usePageMeta } from "../hooks/usePageMeta";
import "../components/Chip/Chip.css";

function Home() {
  const [activeChip, setActiveChip] = useState("UX/UI Design");
  const coverImage = `${window.location.origin}${process.env.PUBLIC_URL}/cover.png`;

  usePageMeta({
    ogType: "website",
    ogImage: coverImage,
    ogUrl: window.location.href,
  });

  return (
    <>

      <Herobanner />

      <Section id="MY WORK" headingText="My Work" viewAllLink="/work">
        <div className="chip-row">
          <Chip
            content="UX/UI Design"
            clicked={activeChip}
            onClick={setActiveChip}
          />
          <Chip
            content="UX Writing"
            clicked={activeChip}
            onClick={setActiveChip}
          />
          <Chip
            content="Content Writing"
            clicked={activeChip}
            onClick={setActiveChip}
          />
        </div>
        <CardContainer isClicked={activeChip} limit={4} />
      </Section>

      <Section id="CERTIFICATION" headingText="Certification" viewAllLink="/certifications">
        <CertificationContainer limit={2} />
      </Section>

      <Section id="ARTICLE" headingText="Article" viewAllLink="/articles">
        <ArticleContainer limit={2} />
      </Section>

      <Stripbanner />
    </>
  );
}

export default Home;
